export default {"src":"/_next/static/image/public/assets/icons/parking.44fbee7dafa14da8746bcde784902af8.svg","height":24,"width":24};